import { createAsyncThunk } from '@reduxjs/toolkit';
//import Config from '../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';
import { clearStateHistoryAction } from '../../../utilities/stateHistory/stateHistorySlice';
import { ESIM_UPGRADE_RETURN_FROM_QR_KEY, ESIM_UPGRADE_RETURN_URL_KEY } from '../EsimUpgradeBlock/esimUpgradeNavigationConstants';
import { getEsimTypeCode } from '../../../utilities/domain/simTypeConstants';
import { initBlock, goToPage, goToPageWithoutHistory, setIsLoadingQrCode, setIsGetQrCodeError, setQrCodeDetails, setLoginDetails, setErrorPage, setActivateEsimStep } from './EsimQrCodeBlockSlice';

const isEsimUpgradeQrCodeFlow = (authentication) =>
    authentication?.loginData?.magicLinkParameters?.scopeName?.toUpperCase() === 'ESIMUPGRADEQRCODE';

const getEsimUpgradeReturnUrl = () => {
    const storedUrl = sessionStorage.getItem(ESIM_UPGRADE_RETURN_URL_KEY);
    if (storedUrl) {
        return storedUrl;
    }

    const prevUrl = sessionStorage.getItem('prevFullUrl') || '';
    const match = prevUrl.match(/(\/selfcare\/esimupgrade\/?)/i);
    if (match) {
        return match[1];
    }

    return window.location.pathname.replace(/esimqrcode/i, 'esimupgrade');
};

const QR_CODE_EXPLICIT_BACK_PAGE = {
    installEsimOnMobilePage: 'activateEsimPage',
    activationCodesPage: 'instructionsPage',
    videoPage: 'instructionsPage',
    whatsAppSuccessPage: 'instructionsPage',
    errorPage: 'instructionsPage',
};

const SIM_REMOVAL_STEP = 2;


export const prepareBlockAsync = createAsyncThunk('esimQrCodeBlock/prepareBlockAsync', async (isIdfAction, thunkAPI) => {
  try {
    const authentication = thunkAPI.getState().authentication;
    let phoneNumber = null;

    if (isIdfAction) {
      const idfStore = thunkAPI.getState().idfSale;
      const esimQrCodeStore = thunkAPI.getState().esimQrCodeBlock;
      phoneNumber = validatePhoneNumber(idfStore?.userDetails?.existing_line_code !== "" ? idfStore?.userDetails?.existing_line_code : idfStore?.userDetails?.new_line_code);
      await thunkAPI.dispatch(setLoginDetails({subscriberNo: phoneNumber}));
      await thunkAPI.dispatch(getQrCodeAsync({ isIdfAction: isIdfAction, idfExistingLineCode: phoneNumber, isDisplayLoader: true }));

    } else {
      const magicLinkParameters = authentication.loginData?.magicLinkParameters;
      if (magicLinkParameters?.scopeName?.toUpperCase() == 'ESIMPROVIDENP' && !authentication?.loginData?.userDetails?.IDNumber) {
        thunkAPI.dispatch(setErrorPageAsync({error: 'NIUD_NOT_FINISH_ERROR'}));
        return;
      }
      phoneNumber = magicLinkParameters?.phoneNumber;
      thunkAPI.dispatch(setLoginDetails({subscriberNo: phoneNumber}));
    }

    } catch (error) {

  } finally {
  }
});


export const getQrCodeAsync = createAsyncThunk('esimQrCodeBlock/getQrCodeAsync', async (data, thunkAPI) => {
    try {

        if (data?.isDisplayLoader) {
            thunkAPI.dispatch(showAppLoader());
        }
        else {
            thunkAPI.dispatch(setIsLoadingQrCode(true));
        }


        thunkAPI.dispatch(setIsGetQrCodeError(false));

        const state = thunkAPI.getState().esimQrCodeBlock;
        const authentication = thunkAPI.getState().authentication;
        const magicLinkParameters = authentication.loginData?.magicLinkParameters;

        // const subscriberNo = state.loginDetails.subscriberNo;
        // const orderId = state.orderDetails.orderId ? state.orderDetails.orderId : magicLinkParameters?.orderNumber;
        // const isJet = (state.checkUserResponse.isJet || magicLinkParameters?.sourceSystem == 'JET');

        const subscriberNo = magicLinkParameters?.phoneNumber;
        const orderId = magicLinkParameters?.orderNumber;
        const isJet = (magicLinkParameters?.sourceSystem == 'JET');

        const params = {
            personalInfo: {
                isJet: isJet,
                phoneNumberToReplace: data?.isIdfAction ? data?.idfExistingLineCode : subscriberNo,
            },
            orders: [
                {
                    orderId: (orderId ? orderId : '0'),
                    orderType: getEsimTypeCode(),
                    isAdvanceOrder: state.esimBlockData.isAdvanceOrder
                }
            ]
        };

        const result = await ProviderManager.getProviderData('getQrCodeUpgrade', params);
        const isSuccess = (result?.Header?.ReturnCode == 0 && result?.Body?.successResult?.isSuccess);

        const subscriberDetails = result?.Body?.SUBSCRIBER_DETAILS?.[0] ?? {};
        const base64QrCode = subscriberDetails.QRCODE;
        const activationCode = subscriberDetails.ACTIVATION_CODE;
        const smdp = subscriberDetails.SMDP;
        const accessCode = subscriberDetails.AC_TOKEN;
        const appleUniversalLink = subscriberDetails.APPLE_UNIVERSAL_LINK;
        const androidUniversalLink = subscriberDetails.ANDROID_UNIVERSAL_LINK;

        if (isSuccess && (base64QrCode || appleUniversalLink || androidUniversalLink)) {
            const qrCodeDetails = {
                base64QrCode: base64QrCode ?? '',
                activationCode: activationCode ?? '',
                smdp: smdp ?? '',
                accessCode: accessCode ?? '',
                appleUniversalLink: appleUniversalLink ?? '',
                androidUniversalLink: androidUniversalLink ?? '',
            };
            thunkAPI.dispatch(setQrCodeDetails(qrCodeDetails));
        }
        else {
            thunkAPI.dispatch(setIsGetQrCodeError(true));
        }

        return result;

    } catch (error) {
        thunkAPI.dispatch(setIsGetQrCodeError(true));
    } finally {
        if (data?.isDisplayLoader) {
            thunkAPI.dispatch(hideAppLoader());
        }
        else {
            thunkAPI.dispatch(setIsLoadingQrCode(false));
        }
    }
});


export const checkIfWhatsAppActiveAsync = createAsyncThunk('esimQrCodeBlock/checkIfWhatsAppActiveAsync', async (data, thunkAPI) => {
    try {
        const whatsResult = await ProviderManager.getProviderData('getEsimWhatsAppActivity', []);
        //const isWhatsAppActive = whatsResult?.Body;
        return whatsResult;
    } catch (error) {

    } finally {

    }
});


export const setErrorPageAsync = createAsyncThunk('esimQrCodeBlock/setErrorPageAsync', async (data, thunkAPI) => {

    thunkAPI.dispatch(showAppLoader());

    /*
        GET_PRICE_ERROR
        CHECK_USER_ERROR
        ORDER_NUMBER_ERROR
        CHECK_USER_ERROR
        CHECK_USER_ERROR_BUSINESS_USER
        GET_SUBSCRIBERS_ERROR
        CREATE_ESIM_ORDER_ERROR
        NO_ORDER_ERROR
        ERROR_OPEN_CHAT_ERROR
        NIUD_NOT_FINISH_ERROR
    */

    const params = { errorDescription: data.error };
    thunkAPI.dispatch(setErrorPage(params));

    thunkAPI.dispatch(hideAppLoader());

});


export const openWhatsAppChatAsync = createAsyncThunk('esimQrCodeBlock/openWhatsAppChatAsync', async (data, thunkAPI) => {

    thunkAPI.dispatch(showAppLoader());

    try {
        const state = thunkAPI.getState().esimQrCodeBlock;

        // const whatsAppResult = await thunkAPI.dispatch(checkIfWhatsAppActiveAsync());
        // const isWhatsAppActive = whatsAppResult?.payload?.Body;

        const isWhatsAppActive = true;// 24\7
        if (!isWhatsAppActive) {
            thunkAPI.dispatch(setErrorPageAsync({ error: 'ERROR_OPEN_CHAT_ERROR' }));
            return;
        }

        var params = {
            phoneNumber: state.loginDetails.subscriberNo,
            fullAddress: '',
            messageText: 'פנייה בתהליך ESIM'
        }

        const result = await ProviderManager.getProviderData('esimOpenWhatsApp', params);
        const isSuccess = (result?.Header?.ReturnCode == 0 && result?.Body?.isSuccess);

        if (isSuccess) {
            thunkAPI.dispatch(goToPage('whatsAppSuccessPage'));
        }
        else {
            thunkAPI.dispatch(setErrorPageAsync({ error: 'ERROR_OPEN_CHAT_ERROR' }));
        }

        return result;

    } catch (error) {
        thunkAPI.dispatch(setErrorPageAsync({ error: 'ERROR_OPEN_CHAT_ERROR' }));
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }

});


export const createMemoAsync = createAsyncThunk('esimQrCodeBlock/createMemoAsync', async (data, thunkAPI) => {
    try {
        const params = {};
        ProviderManager.getProviderData('createMemoIntCr', params);
    }
    catch {

    } finally {

    }
});

export const validatePhoneNumber = (phoneNumber) => {
  if (phoneNumber && phoneNumber.length > 0 && phoneNumber[0] !== '0') {
    return '0' + phoneNumber;
  }
  return phoneNumber;
};

export const navigateBackToEsimUpgradeStartAsync = createAsyncThunk(
    'esimQrCodeBlock/navigateBackToEsimUpgradeStartAsync',
    async (_, thunkAPI) => {
        await thunkAPI.dispatch(clearStateHistoryAction());
        sessionStorage.setItem(ESIM_UPGRADE_RETURN_FROM_QR_KEY, '1');
        EpiContext.navigateTo(getEsimUpgradeReturnUrl());
    },
);

export const navigateEsimQrBack = () => (dispatch, getState) => {
    dispatch(hideAppLoader());
    const state = getState();
    const { page, activateEsimStep, activateEsimMinStep } = state.esimQrCodeBlock;

    if (page === 'instructionsPage') {
        dispatch(setActivateEsimStep(SIM_REMOVAL_STEP));
        dispatch(goToPageWithoutHistory('activateEsimPage'));
        return;
    }

    if (page === 'activateEsimPage') {
        if (activateEsimStep > activateEsimMinStep) {
            dispatch(setActivateEsimStep(activateEsimStep - 1));
            return;
        }
        if (isEsimUpgradeQrCodeFlow(state.authentication)) {
            dispatch(navigateBackToEsimUpgradeStartAsync());
            return;
        }
        window.history.back();
        return;
    }

    const explicitBackPage = QR_CODE_EXPLICIT_BACK_PAGE[page];
    if (explicitBackPage) {
        dispatch(goToPageWithoutHistory(explicitBackPage));
        return;
    }

    window.history.back();
};
